import React, { useEffect, useState, useRef } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import Button from '@mui/material/Button'
import './MemberlistDialog.scss'
import { getMembers, createMemberSession } from './MemberListDialogFunctions'
import Interceptor from '../../../Services/serviceBase.interceptor'
import { useErrorSnackBarContext } from '../ErrorSnackBar/ErrorSnackBarContext'

function MemberlistDialog({ title = 'Select Member', open = false, onClose, fireDepartmentId, setMemberlistDialog, setIarMember }) {
  const {errorSnackBarActions } = useErrorSnackBarContext()
  Interceptor.interceptor(errorSnackBarActions)
  const [memberlistDialogState, setMemberlistDialogState] = useState({
    members: [],
    moreThanZeroMembers: true
  })
  const getMemberlistRef = useRef(null)
  const memberValueFromAutocompleteRef = useRef()
  getMemberlistRef.current = open

  useEffect(() => {
    const fetch = async () => {
      const { MemberList, moreThanOneMember } = await getMembers(
        fireDepartmentId,
        errorSnackBarActions
      )
      setMemberlistDialogState({
        members: MemberList,
        moreThanZeroMembers: moreThanOneMember
      })
    }

    if (getMemberlistRef.current) {
      fetch()
    }
  }, [open])

  return (
    <div>
      <Dialog className="news-dialog" disableBackdropClick disableEscapeKeyDown open={open}>
        <DialogTitle className="news-dialog-title">
          <span>{title}</span>
          <IconButton aria-label="close" className="close-button" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent id="memberlist-container">
          <span id="span-name">Name</span>
          {!memberlistDialogState.moreThanZeroMembers && (
            <>
              <br />
              <span className="no-members">There are no members for this option</span>
            </>
          )}
          <div id="autocomplete-container">
            <Autocomplete
              id="combo-box-demo"
              options={
                memberlistDialogState.moreThanZeroMembers ? memberlistDialogState.members : []
              }
              getOptionLabel={(option) => option.fullName}
              renderInput={(params) => (
                <TextField
                  inputRef={memberValueFromAutocompleteRef}
                  {...params}
                  label={false}
                  variant="outlined"
                />
              )}
            />
          </div>
          <div id="memberlist-btn-container">
            <Button color="primary" className="memberlist-btn" onClick={onClose}>
              Cancel
            </Button>
            <Button
              color="primary"
              variant="contained"
              className="memberlist-btn"
              onClick={() =>
                createMemberSession(
                  memberlistDialogState.members,
                  memberValueFromAutocompleteRef.current.value,
                  errorSnackBarActions,
                  setMemberlistDialog,
                  setIarMember
                )
              }
            >
              Ok
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default MemberlistDialog
